import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { UserRound } from "lucide-react";

const PersonAvatar = ({
  firstName,
  lastName,
  imageSrc,
  className = "size-12",
}: {
  firstName?: string;
  lastName?: string;
  imageSrc?: string;
  className?: string;
}) => {
  const initials =
    firstName && lastName
      ? `${firstName[0]?.toUpperCase()}${lastName[0]?.toUpperCase()}`
      : undefined;
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  return (
    <Avatar className={className}>
      {imageSrc && <AvatarImage src={imageSrc} alt={fullName} />}
      <AvatarFallback>
        {initials ?? <UserRound strokeWidth={1} />}
      </AvatarFallback>
    </Avatar>
  );
};

export default PersonAvatar;
